module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "vue-touch"
    }
  }, [_c('v-touch', {
    staticClass: "vue-touch",
    on: {
      "tap": _vm.test,
      "swipeleft": _vm.onSwipeLeft,
      "swiperight": _vm.onSwipeRight
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 1),
      expression: "page == 1"
    }]
  }, [_vm._v("Page 1")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 2),
      expression: "page == 2"
    }]
  }, [_vm._v("Page 2")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 3),
      expression: "page == 3"
    }]
  }, [_vm._v("Page 3")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page == 4),
      expression: "page == 4"
    }]
  }, [_vm._v("Page 4")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55e4f5be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vueTouch/component.vue
// module id = 3774
// module chunks = 1